export type PartyEntryContext = 'CUSTOMER' | 'SUPPLIER' | 'NEUTRAL';

export function resolveRegisterPartyTitle(entryContext: PartyEntryContext): string {
  switch (entryContext) {
    case 'CUSTOMER':
      return 'Novo cliente';
    case 'SUPPLIER':
      return 'Cadastrar fornecedor';
    case 'NEUTRAL':
      return 'Novo cadastro';
  }
}

export function resolveRegisterPartyTrailParent(entryContext: PartyEntryContext): string {
  switch (entryContext) {
    case 'CUSTOMER':
      return 'Clientes';
    case 'SUPPLIER':
      return 'Fornecedores';
    case 'NEUTRAL':
      return 'Cadastros';
  }
}

export function resolveRegisterPartyTrail(
  entryContext: PartyEntryContext,
): readonly [string, string] {
  const title = resolveRegisterPartyTitle(entryContext);
  return [resolveRegisterPartyTrailParent(entryContext), title];
}

export function shouldSkipCustomerRoleOnRegister(entryContext: PartyEntryContext): boolean {
  return entryContext === 'SUPPLIER' || entryContext === 'NEUTRAL';
}
